export const DEFAULT_CONFIGURATION = {
  TYPE: "fixed",
  SIZE: {
    fixed: "x_small",
    free: "small"
  },
  SEASON: "summer",
  FOUNDATION: "already_completed",
  CONSTRUCTION_SUPPORT: "none"
};
